/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { dipPostRequestSchema } from './dipPostRequestSchema.ts';
import { dipPostResponseSchema } from './dipPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postDip200Schema = z.lazy(() => dipPostResponseSchema);

/**
 * @description 505 response
 */
export const postDip505Schema = z.any();

export const postDipMutationRequestSchema = z.lazy(() => dipPostRequestSchema);

export const postDipMutationResponseSchema = z.lazy(() => postDip200Schema);
